import { render, staticRenderFns } from "./SpecialControlStockReportView.vue?vue&type=template&id=6f727b4e&scoped=true"
import script from "./SpecialControlStockReportView.vue?vue&type=script&lang=js"
export * from "./SpecialControlStockReportView.vue?vue&type=script&lang=js"
import style0 from "./SpecialControlStockReportView.vue?vue&type=style&index=0&id=6f727b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f727b4e",
  null
  
)

export default component.exports